/* import __COLOCATED_TEMPLATE__ from './string-filter.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { type Filter, Operator } from '../steps/filter';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  filter: Filter;
  index: number;
  removeFilter: (index: number) => void;
  setPredicate: (predicate: any, index: number) => void;
}

export default class StandaloneSalesforceSetupArticleSyncFilterItemsStringFilter extends Component<Args> {
  @service declare intl: IntlService;

  @tracked selectedOperator = this.initialSelectedOperator;
  @tracked value = this.initialValue;

  get initialSelectedOperator() {
    if (this.args.filter.predicate.operator === undefined) {
      return Operator.Equal;
    }

    return this.args.filter.predicate.operator;
  }

  get initialValue() {
    if (this.args.filter.predicate.value === undefined) {
      return '';
    }

    return this.args.filter.predicate.value as string;
  }

  get filterBlockDetails() {
    return `${this.selectedOperator} ${this.value}`;
  }

  get radioButtons() {
    return [
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.equals',
        ),
        value: Operator.Equal,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.not-equals',
        ),
        value: Operator.NotEqual,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.contains',
        ),
        value: Operator.Like,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.not-contains',
        ),
        value: Operator.NotLike,
      },
    ];
  }

  get predicate() {
    return {
      ...this.args.filter.predicate,
      operator: this.selectedOperator,
      value: this.value,
    };
  }

  @action
  onClose() {
    this.args.setPredicate(this.predicate, this.args.index);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::ArticleSync::FilterItems::StringFilter': typeof StandaloneSalesforceSetupArticleSyncFilterItemsStringFilter;
    'standalone/salesforce/setup/article-sync/filter-items/string-filter': typeof StandaloneSalesforceSetupArticleSyncFilterItemsStringFilter;
  }
}
